import { ref, computed } from '@nuxtjs/composition-api';

const isAnimationsPaused = ref(false);

export const useAnimationControl = () => {
  const toggleAnimations = () => {
    isAnimationsPaused.value = !isAnimationsPaused.value;
    
    if (typeof window === 'undefined') return;
    
    // Gestione video Brightcove (video-js)
    const brightcoveVideos = document.querySelectorAll('.video-js');
    brightcoveVideos.forEach((videoEl) => {
      try {
        //@ts-ignore
        const player = window.videojs && window.videojs(videoEl);
        if (player) {
          if (isAnimationsPaused.value) {
            player.pause && player.pause();
          } else {
            player.play && player.play().catch((e) => {
              console.warn('Error resuming brightcove video:', e);
            });
          }
        }
      } catch (e) {
        console.warn('Error controlling brightcove video:', e);
      }
    });
    
    // Gestione video HTML normali
    const regularVideos = document.querySelectorAll('video:not(.video-js)');
    regularVideos.forEach((video: HTMLVideoElement) => {
      if (isAnimationsPaused.value) {
        video.pause();
      } else {
        // Riprendi solo i video che erano in autoplay
        if (video.hasAttribute('autoplay') || video.closest('[data-autoplay="true"]')) {
          video.play().catch(() => {
            // Ignora errori di autoplay
          });
        }
      }
    });
    
    // Gestione animazioni CSS (marquee, etc.)
    const animatedElements = document.querySelectorAll('.animate-marquee, [class*="animate-"]');
    animatedElements.forEach((element: HTMLElement) => {
      if (isAnimationsPaused.value) {
        element.style.animationPlayState = 'paused';
      } else {
        element.style.animationPlayState = 'running';
      }
    });

    // Gestione autoplay swiper logos carousel
    const swiperCarousels = document.querySelectorAll('.logos-carousel .swiper-container');
    swiperCarousels.forEach((carousel: any) => {
      const swiper = carousel.swiper;
      if (!swiper) return;
      if (isAnimationsPaused.value) {
        // stopping autplay and transition to freeze carousel immediately
        swiper.autoplay.stop();
        swiper.setTranslate(swiper.getTranslate());
      } else {
        swiper.update();
        swiper.autoplay.start();
      }
    });
  };

  const pauseAnimations = () => {
    if (!isAnimationsPaused.value) {
      isAnimationsPaused.value = true;
      toggleAnimations();
    }
  };

  const resumeAnimations = () => {
    if (isAnimationsPaused.value) {
      isAnimationsPaused.value = false;
      toggleAnimations();
    }
  };

  return {
    isAnimationsPaused: computed(() => isAnimationsPaused.value),
    isPaused: computed(() => isAnimationsPaused.value),
    toggleAnimations,
    pauseAnimations,
    resumeAnimations,
  };
};
